module.exports = __webpack_public_path__ + "static/media/bmz.5973cc33.png";